export default __webpack_public_path__ + "static/media/right.8ba4b55f.svg";